import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const bankAccountsRoutes: RouteRecordRaw[] = [
  {
    path: routes.BANK_ACCOUNTS,
    name: 'BANK_ACCOUNTS',
    component: () => import('./BankAccountsPage.vue'),
    meta: { requiresAuth: true, title: 'Bank Accounts' },
  },
  {
    // Legacy deep-link — redirects to /bank-accounts?action=add so the drawer
    // pre-opens. Kept so existing links / emails don't break.
    path: routes.ADD_BANK_ACCOUNT,
    name: 'ADD_BANK_ACCOUNT',
    redirect: { path: routes.BANK_ACCOUNTS, query: { action: 'add' } },
    meta: { requiresAuth: true },
  },
  {
    // Account details is a full page in the new design, not a drawer over the
    // list — so this is a real route again rather than a redirect to `?id=`.
    path: routes.BANK_ACCOUNT_DETAIL,
    name: 'BANK_ACCOUNT_DETAIL',
    component: () => import('./BankAccountDetailPage.vue'),
    meta: { requiresAuth: true, title: 'Account Details' },
  },
]
